import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { ReceiptService } from '../services/receipt.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GlobalVariable } from 'src/app/shared/global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from "src/app/store/reducer";
import { OpenAdvanceSearchModal } from '../../store/actions';
import { Tab } from 'src/app/shared/model/tab.model';
import { TabService } from 'src/app/shared/services/tab.service';
import { V2CreateReceiptComponent } from '../v2-create-receipt/v2-create-receipt.component';
import * as moment from 'moment';

@Component({
	selector: 'app-view-receipt',
	templateUrl: './view-receipt.component.html',
	styleUrls: ['./view-receipt.component.scss']
})
export class ViewReceiptComponent implements OnInit {
	allreceiptArr: any;
	receiptArr: any;
	navigationSubscription;
	reInitialise: any;
	fromRoot = true;
	selector: string = '.main-panel';
	fromIndex: any = 0;
	toIndex: any = 30;
	p;
	innerHeight: string;
	onSearch;
	onSearchFilter = new Subject<string>();

	isAdvancedSearchOpen: boolean = false;
	currentIndex=0
	@ViewChild('tableHeader', {static:true}) tableHeader : ElementRef
	duration: any;
	loader: boolean = false;
	queryParams: any;

	constructor(
		private receiptService: ReceiptService,
		private route: ActivatedRoute,
		public commonService: CommonServiceService,
		private store: Store<InitialState>,
		private router: Router,
		private tabService : TabService
	) {
		this.navigationSubscription = this.router.events.subscribe((e: any) => {
			// If it is a NavigationEnd event re-initalise the component
			if (e instanceof NavigationEnd) {
				this.initialiseInvites();
			}
		});
	 }

	ngOnInit() {
		let queryParams = JSON.parse(JSON.stringify(this.route.queryParams['value']))
		let currentFinancialSession = this.commonService.getFinancialSession(moment()).toString()
		if(sessionStorage.getItem("current_financial_year") && JSON.parse(sessionStorage.getItem("current_financial_year"))['start_date']){
			currentFinancialSession = `${this.commonService.getFinancialSession(JSON.parse(sessionStorage.getItem("current_financial_year"))['start_date'])}`
		}
		if(!queryParams.start_date){
			queryParams.start_date = moment().subtract(7, 'd').format('YYYY-MM-DD');
			let requestedFinancialSession = this.commonService.getFinancialSession(queryParams.start_date)
			if(currentFinancialSession!=requestedFinancialSession){
				queryParams.start_date = `${currentFinancialSession}-04-01`
			}
		}
		if(!queryParams.end_date){
			queryParams.end_date = moment().format('YYYY-MM-DD');
			let requestedFinancialSession = this.commonService.getFinancialSession(queryParams.end_date)
			if(currentFinancialSession!=requestedFinancialSession){
				queryParams.end_date = `${currentFinancialSession}-04-30`
			}
		}
		this.fromIndex = 0;
		queryParams['limit'] = 30;
        queryParams['offset'] = this.fromIndex;
		this.onSearch = ''
		if (queryParams.from_account != undefined) {
			localStorage.setItem('activeReceiptQueryParams',JSON.stringify(queryParams))
			this.search(queryParams)
		} else {
			this.search(queryParams)

		}
		this.queryParams = queryParams;
		this.reInitialise=true
		this.onSearchFilter.pipe(
			debounceTime(300),
			distinctUntilChanged())
			.subscribe(value => {
			  this.filterData(value)
		});
	}

	initialiseInvites() {
		if (this.reInitialise) {
			this.ngOnInit()
		}
	}
	ngOnDestroy() {
		// avoid memory leaks here by cleaning up after ourselves. If we  
		// don't then we will continue to run our initialiseInvites()   
		// method on every navigationEnd event.
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.setHeight(event.target.innerHeight)
	}	

	openAdvanceSearchModal(){
		this.store.dispatch(new OpenAdvanceSearchModal({status: true,title : 'receipt'}));	
	}
	async search(values) {
		let reqObj = Object.assign({},values)
		
		this.loader = true;
		let resp = await this.getData(reqObj)
		if(resp){
			this.loader = false;
			this.duration = resp['duration']
			this.allreceiptArr = resp['data']
			this.receiptArr = resp['data']
			this.focusOnTableHeader()
			this.currentIndex = 0
			this.setHeight(window.innerHeight)
	    }
	}

	getData(values){
		return new Promise(async (resolve, reject) => {
			this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/receipt`, values).subscribe(res => {
				resolve(res)
			},err=> {
				resolve(null)
			})
		})
	}

	
	setHeight(height) {
		if (this.receiptArr != undefined) {
			if (height == undefined) {
				height = window.innerHeight
			}
			if (this.receiptArr.length <= 9) {
				this.innerHeight = 'auto';
			}
			else {
				this.innerHeight = height - 147 + 'px';
			}
		}
	}

	openReceipt(receipt_code){
		let path=`${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/receipt/view/${receipt_code}`
		if(window.location.protocol != 'file:'){
				let title =''
				let receiptParts = receipt_code.split('-')
				title += receiptParts[0]
				title +='...'
				title += receiptParts[receiptParts.length-1]
			if(receipt_code) {
				this.tabService.addTab(
					new Tab(V2CreateReceiptComponent, `${title}`, { receiptRef: receipt_code ,mode: 'view'}, receipt_code)
					);
			} else {
				window.open(path,'_blank')
			}
		}else{
			var customeEventHandler = new CustomEvent("handle-window-open", {
				"detail": {
					hashPath : path
				}
			  });
			window.dispatchEvent(customeEventHandler)
		}
	}

	focusOnTableHeader(){
		if(this.tableHeader != undefined){
			this.tableHeader.nativeElement.focus()
		}
	}
	
	// @HostListener('window:keydown', ['$event'])
	onKeyDown(e: any) {
		console.log('openModalStatus : ' + GlobalVariable.openModalStatus)
		if (GlobalVariable.openModalStatus == false && GlobalVariable.openGlobalSearch == false)
		{
			if (e.keyCode == 40) {
				e.preventDefault();
				this.moveToNext()
			} else if (e.keyCode === 38) {
				e.preventDefault();
				this.moveToPrev()
			}
		}
	}
	moveToNext(){
		if (document.getElementById(`rowIndex_${this.currentIndex+1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex+1}`).focus()
			this.currentIndex = this.currentIndex+1
		}
	}
	moveToPrev(){
		if (document.getElementById(`rowIndex_${this.currentIndex-1}`) != null) {
			document.getElementById(`rowIndex_${this.currentIndex-1}`).focus()
			this.currentIndex = this.currentIndex-1
		}
	}
	
	moveToIndex(i){
		document.getElementById(`rowIndex_${i+1}`).focus()
		this.currentIndex = i+1
	}

	async onScrollDown(event) {
		this.fromIndex +=30
		let queryParams = JSON.parse(JSON.stringify(this.queryParams))
		queryParams['limit'] = 30;
		queryParams['offset'] = this.fromIndex;
		let resp = await this.getData(queryParams)
		if(resp){
			this.receiptArr = this.receiptArr.concat(resp['data'])
			this.setHeight(window.innerHeight)
		}
	}

	onScrollUp(event) {
	}
	
	oldFilterData(value) {
		let tempArr = Object.assign([], this.allreceiptArr)
		if (value.length > 2) {
			let lowerCaseFilter = value.toLowerCase()
			let upperCaseFilter = value.toUpperCase()
			this.receiptArr = tempArr.filter(
				receiptData => {
					if (	
						(
							receiptData.account_code_to != undefined && 
							receiptData.account_code_to != null && 
							(	receiptData.account_code_to.includes(value) || 
								receiptData.account_code_to.includes(upperCaseFilter) ||
								receiptData.account_code_to.includes(lowerCaseFilter)
							)
						) || 
						(
							receiptData.receipt_code != undefined && 
							receiptData.receipt_code != null && 
							(	receiptData.receipt_code.includes(value) || 
								receiptData.receipt_code.includes(upperCaseFilter) ||
								receiptData.receipt_code.includes(lowerCaseFilter)
							)
						) ||

						(
							receiptData.account_code_from_name != undefined && 
							receiptData.account_code_from_name != null && 
							(	receiptData.account_code_from_name.toString().includes(value) || 
								receiptData.account_code_from_name.toString().includes(upperCaseFilter) ||
								receiptData.account_code_from_name.toString().includes(lowerCaseFilter)
							)
						) || 
						(
							receiptData.account_code_to_name != undefined && 
							receiptData.account_code_to_name != null && 
							(	receiptData.account_code_to_name.toString().includes(value) || 
								receiptData.account_code_to_name.toString().includes(upperCaseFilter) ||
								receiptData.account_code_to_name.toString().includes(lowerCaseFilter)
							)
						) ||
						(
							receiptData.amount != undefined && 
							receiptData.amount != null && 
							(	receiptData.amount.toString().includes(value) || 
								receiptData.amount.toString().includes(upperCaseFilter) ||
								receiptData.amount.toString().includes(lowerCaseFilter)
							)
						)
					)  
					
					{
						return receiptData
					}
				}
			)
			this.setHeight(window.innerHeight)
		} else{
			this.receiptArr = []
			for (let i = 0; i <= 30; i++) {
				const element = this.allreceiptArr[i];
				if (element != undefined) {
					this.toIndex = i
					this.receiptArr.push(element)
				}
			}
			this.setHeight(window.innerHeight)
		}
	}

	async filterData(value) {
        if (value.length >= 0) {
            this.queryParams['freetext'] = value
            let queryParams = JSON.parse(JSON.stringify(this.queryParams))
            this.queryParams = queryParams
			this.fromIndex=0
            queryParams['limit'] = 30;
            queryParams['offset'] = this.fromIndex;
			this.loader = true
            let resp = await this.getData(queryParams)
			this.loader = false
            if(resp){
                this.receiptArr = resp['data']
				let firstRow = document.getElementById('rowIndex_1') as HTMLElement
				if(firstRow){
					firstRow.scrollIntoView()
				}

            }
           
        this.setHeight(window.innerHeight)
        } else {
            delete this.queryParams['freetext']
            this.search(this.queryParams)
            this.setHeight(window.innerHeight)
        }
    }


}
